import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { setPenDescription, setPenTitle } from '../../redux/actions/penActions'
export default function PenDetails() {
    const dispatch = useDispatch()
    const {pen_description, pen_title} = useSelector(state => state.penReducer)
        return (
            <div className="penDetails">
                <h2>Pen Title</h2>
                <input type="text" value={pen_title} onChange={(e) => dispatch(setPenTitle(e.target.value))} />
                <h2>Pen Description</h2>
                <textarea 
                    type="text" 
                    value={pen_description} 
                    onChange={(e) => dispatch(setPenDescription(e.target.value))} 
                    placeholder="Explain what's going on in your pen here.  This text is searchable, so it can also help others find your work.  Remember to credit others where credit is due." />
            </div>
        )
    }



// WEBPACK FOOTER //
// ./src/components/PenSettings/PenDetails.js